import Input from './Input';

export const Textarea = ({ rows = 2, ...props }) => (
    <Input
        type="textarea"
        rows={rows}
        {...props}
    />
);